
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/voktun-samfelagsmidla",
      function () {
        return require("private-next-pages/um/thjonusta/voktun-samfelagsmidla.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/voktun-samfelagsmidla"])
      });
    }
  